var map = {
	"./common/empty.png": 25784,
	"./common/frame-corner-bottom-left.png": 33798,
	"./common/frame-corner-bottom-right.png": 97563,
	"./common/frame-corner-top-left.png": 7038,
	"./common/frame-corner-top-right.png": 33171,
	"./common/gift.png": 3057,
	"./common/hot.gif": 12633,
	"./event/top-bg.png": 77277,
	"./event/top-right.png": 34192,
	"./event/top-shell-bg.png": 35698,
	"./footer/border-body.png": 19390,
	"./footer/border-top.png": 5793,
	"./header/dropdown-arrow.png": 54424,
	"./header/menu-toggle.png": 53481,
	"./header/mobile-arrow.png": 9809,
	"./home/banner-bg.png": 60275,
	"./home/category-favorite.webp": 10953,
	"./home/category-hot-active.png": 14660,
	"./home/category-hot.png": 78767,
	"./home/category-popular.webp": 70738,
	"./home/category-recent-active.png": 78106,
	"./home/category-recent.png": 19801,
	"./home/category-recent.webp": 33106,
	"./home/category-slots.webp": 25802,
	"./home/event-card-corner-bottom-left.png": 35396,
	"./home/event-card-corner-bottom-right.png": 95041,
	"./home/event-card-corner-top-left.png": 93624,
	"./home/event-card-corner-top-right.png": 10061,
	"./home/frame-corner-bottom-left.png": 17876,
	"./home/frame-corner-bottom-right.png": 67633,
	"./home/frame-corner-top-left.png": 25768,
	"./home/frame-corner-top-right.png": 63549,
	"./home/game-section-header-bg.png": 19299,
	"./home/jackpot-bg.png": 83475,
	"./home/notice-icon.webp": 656,
	"./home/page-bg.png": 88934,
	"./home/redeem-code-icon.png": 41293,
	"./home/search-active.png": 40982,
	"./home/search.png": 82589,
	"./login/exit-confirm-bg.png": 55130,
	"./login/popup-bg.png": 43853,
	"./notification/bg-top1.png": 51925,
	"./person/avatar.png": 66468,
	"./person/bg-vip.png": 76544,
	"./person/bg-vipBottom.png": 20657,
	"./person/bg-vipPc.png": 78915,
	"./person/icon-Deposit.png": 39129,
	"./person/icon-DepositVip.png": 79352,
	"./person/icon-History.png": 81123,
	"./person/icon-Install.png": 14386,
	"./person/icon-Notification.png": 79022,
	"./person/icon-Senha.png": 44912,
	"./person/icon-Transaction.png": 17083,
	"./person/icon-Withdraw.png": 41845,
	"./person/icon-arrow.png": 20672,
	"./person/icon-betsVip.png": 92950,
	"./person/icon-exchange.png": 69164,
	"./person/icon-service.png": 39930,
	"./person/icon_Wallet.png": 46998,
	"./person/icon_copy.png": 12330,
	"./person/icon_logout.png": 3059,
	"./person/icon_notification.png": 73876,
	"./person/vip-center-bg.png": 74348,
	"./person/vip-membership-emblem.jpg": 94558,
	"./share/TreasureChest.png": 83299,
	"./share/TreasureLock.png": 29599,
	"./share/TreasureUnLock.png": 25282,
	"./share/bg-shareMoney.png": 89132,
	"./share/bg-sharePeople.png": 70951,
	"./share/bg-top.png": 4822,
	"./share/facebook.png": 81997,
	"./share/icon_fackbook.png": 55585,
	"./share/icon_howShare.png": 30792,
	"./share/icon_ins.png": 55539,
	"./share/icon_inviteDate.png": 47600,
	"./share/icon_telegram.png": 90822,
	"./share/icon_tiktok.png": 51649,
	"./share/icon_whatsapp.png": 63837,
	"./share/icon_x.png": 38727,
	"./share/icon_youtube.png": 79852,
	"./share/invite_banner1.png": 16348,
	"./share/invite_banner2.png": 23927,
	"./share/invite_banner3.png": 24430,
	"./share/invite_banner4.png": 22913,
	"./share/proxy.png": 10837,
	"./share/redemption-code-title.png": 61159,
	"./share/share_bg.png": 60240,
	"./share/trumpet.png": 61110,
	"./sidebar/affiliate-active.png": 30174,
	"./sidebar/affiliate.png": 11157,
	"./sidebar/copy.png": 14385,
	"./sidebar/customer-service.png": 37328,
	"./sidebar/hot-bg.png": 51693,
	"./sidebar/invite-free.png": 44250,
	"./sidebar/language-arrow.png": 55356,
	"./sidebar/menu-item-border.png": 44048,
	"./sidebar/path-arrow.png": 11871,
	"./sidebar/promotion-active.png": 40468,
	"./sidebar/promotion.png": 75327,
	"./sidebar/redemption-code-active.png": 65736,
	"./sidebar/redemption-code.png": 73851,
	"./sidebar/refresh.png": 89389,
	"./sidebar/share-panel-bg.png": 99758,
	"./sidebar/sidebar-border.png": 40677,
	"./sidebar/social-media-active.png": 31273,
	"./sidebar/social-media.png": 25152,
	"./sidebar/telegram.gif": 54992,
	"./sidebar/vip-active.png": 12038,
	"./sidebar/vip-badge.png": 64451,
	"./sidebar/vip.png": 30861,
	"./signIn/suo.png": 90713,
	"./signIn/vipicon.png": 31144,
	"./signIn/vipiconact.png": 52534,
	"./tabbar/active-corner-bottom-left.png": 15098,
	"./tabbar/active-corner-bottom-right.png": 14487,
	"./tabbar/active-corner-top-left.png": 80242,
	"./tabbar/active-corner-top-right.png": 25743,
	"./tabbar/affiliate-active.png": 5678,
	"./tabbar/affiliate.png": 92069,
	"./tabbar/home-active.png": 21332,
	"./tabbar/home.png": 87295,
	"./tabbar/menu-active.png": 2368,
	"./tabbar/menu.png": 99715,
	"./tabbar/profile-active.png": 38296,
	"./tabbar/profile.png": 90603,
	"./tabbar/sport.png": 75342,
	"./tabbar/vip-active.png": 47382,
	"./tabbar/vip.png": 861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78894;